<template lang="pug">
.spinner(v-if="isFetching")
  .spinner-grow.text-success(role="status")
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isFetching: 'global/isFetching',
    }),
  },
}
</script>

<style lang="stylus" scoped>
.spinner
  align-items center
  display flex
  background-color rgba(#fff, 0.4)
  height 100vh
  justify-content center
  left 0
  position absolute
  top 0
  width 100vw
  z-index 700
</style>
